module.exports = __webpack_public_path__ + "static/img/promptpay.613c98b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/billing/promptpay.png
// module id = ckjh
// module chunks = 1